import getTranslation from '@/locale/getTranslation'

export default [
  {
    path: '/error/busy',
    name: 'busy',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('系统繁忙')
    }
  },
  {
    path: '/error/request-fail',
    name: 'request-fail',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('请求失败')
    }
  },
  {
    path: '/error/no-resule',
    name: 'no-resule',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('无数据')
    }
  },
  {
    path: '/error/no-response',
    name: 'no-response',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('服务器未响应')
    }
  },
  {
    path: '/error/no-permission',
    name: 'no-permission',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('无此操作权限')
    }
  },
  {
    path: '/error/404',
    name: '404',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('页面找不到')
    }
  },
  {
    path: '/error/no-network',
    name: 'no-network',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('无法连接网络')
    }
  },
  {
    path: '/error/no-English',
    name: 'no-English',
    component: () => import('@/views/ErrorPage'),
    meta: {
      title: getTranslation('无英文版')
    }
  }
]
